import React from 'react';
import AppLogo from '@/components/ui/AppLogo';
import OrganizerLogos from '@/components/ui/OrganizerLogos';
import { ShieldCheck } from 'lucide-react';

export default function AuthBrandPanel() {
  return (
    <div className="hidden lg:flex lg:w-[480px] xl:w-[560px] flex-col justify-between gradient-hero px-10 py-12">
      {/* Logo + Event Heading */}
      <div>
        {/* App Logo Row */}
        <div className="flex items-center gap-3 mb-6">
          <AppLogo size={44} />
          <span className="font-sans font-extrabold text-2xl text-white tracking-tight">SmartBLS</span>
        </div>

        {/* Redesigned Event Heading */}
        <div className="mb-6">
          <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 rounded-full px-4 py-1.5 mb-4">
            <span className="w-2 h-2 rounded-full bg-red-400 animate-pulse inline-block" />
            <span className="text-white/90 text-xs font-semibold tracking-wide uppercase">Event Registration Open</span>
          </div>
          <h1 className="font-extrabold text-white leading-tight mb-1" style={{ fontSize: 'clamp(1.5rem, 2.8vw, 2.2rem)' }}>
            NATIONAL BLS DAY 2026
          </h1>
          <p className="text-sky-200 font-bold text-lg leading-snug mb-3">
            BLS MARATHON
          </p>
          <p className="text-white/70 text-base italic font-medium mb-4">
            "A City of Lifesavers in Coimbatore"
          </p>
          <div className="h-px bg-white/20 w-full mb-4" />
          <p className="text-white/65 text-sm leading-relaxed max-w-sm">
            Register for our certified offline BLS training event. Learn life-saving skills, complete your assessment, and earn your certificate.
          </p>
        </div>

        {/* Hosted By — Organizer Logos */}
        <div className="bg-white/10 border border-white/20 rounded-xl px-4 py-4">
          <p className="text-white/60 text-xs font-semibold uppercase tracking-widest mb-3 text-center">Hosted By</p>
          <OrganizerLogos size="md" showLabels variant="dark" layout="grid" />
        </div>
      </div>

      {/* Training Info */}
      <div className="my-6">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center flex-shrink-0">
            <ShieldCheck size={16} className="text-sky-200" />
          </div>
          <span className="text-white/85 text-sm font-medium">
            Basic Life Support Training by American Heart Association Certified Trainers
          </span>
        </div>

        {/* Registration Notice */}
        <div className="mt-4 bg-white/10 border border-white/20 rounded-xl px-4 py-3">
          <p className="text-white/90 text-sm leading-relaxed">
            <span className="font-bold text-white">This training program is free</span> but prior registration is mandatory.
          </p>
          <p className="text-white/80 text-sm mt-1">
            For registration contact:{' '}
            <a href="mailto:iapcoimbatore@gmail.com" className="text-sky-300 font-semibold underline underline-offset-2 hover:text-sky-200 transition-colors">
              iapcoimbatore@gmail.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}